import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";
import { WEBSOCKET_MESSAGE } from "@giantmachines/redux-websocket/dist";

import { Prefixs } from "../../socket/socketPrefix";
import { requestDownloadFileStatus, requestDownloadExecLogsStatus } from "../effects/download-effects";

const initialState = {
  total: 0,
  downloaded: 0,
  status: null,
  loading: false,
  percentage: 0,
  error: "",
};

const downloadSlice = createSlice({
  name: slices.assets,
  initialState,
  extraReducers: {
    ...requestDownloadFileStatus,
    ...requestDownloadExecLogsStatus,
    [`${Prefixs.DOWNLOAD_PREFIX}::${WEBSOCKET_MESSAGE}`]: (state, action) => {
      let message = JSON.parse(action.payload.message);
      // TODO: Check on this
      // Object.assign(newState, message.payload);
      let percentage = (state.downloaded * 100).toFixed(2);
      state.percentage = isNaN(percentage) ? 0 : percentage;
    },
  },
});

const { actions, reducer } = downloadSlice;

export { actions };

export default reducer;
